var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.912 146.912l5.657 5.657c-15.596 15.596-36.083 23.393-56.569 23.393s-40.973-7.797-56.569-23.393C8.24 121.376 8.24 70.624 39.431 39.43c31.193-31.191 81.945-31.191 113.138 0l-5.657 5.657c-28.073-28.072-73.751-28.072-101.824 0-28.072 28.073-28.072 73.75 0 101.824s73.75 28.072 101.824 0zm-4.083-20.083L173.657 96l-30.828-30.829-5.658 5.658L158.343 92H104v8h54.343l-21.172 21.171 5.658 5.658z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.377ff4f2472a8fe679b58b9d25dcba65.svg";
export { ForwardRef as ReactComponent };